module.exports = __webpack_public_path__ + "static/media/lemon_danish.6964d9e8.JPG";